/* eslint-disable max-statements, wrap-iife */
(function($) {
  'use strict';
  // Prevent focus on click
  var $searchTabs = $('.search-tabs');
  if ($searchTabs.length) {
    $searchTabs
      .on('mousedown click', 'a', function(e) {
        e.preventDefault();
        $(e.currentTarget).trigger('blur');
        // Go to url
        window.location.href = $(e.currentTarget).attr('href');
      })
      .on('click', 'button', function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $searchTabs.find('.search-tabs__content').slideToggle(300);
      });
  }
})(jQuery);
